import React from "react";
import { ReadMore } from "../../reusableComponent/readMore";
import { dateFormat } from "../../../helper";
import attachmentIcon from "../../../assets/attachment-icon.svg";
import {
  downloadFile,
  getFileExtension,
  getLabelColor,
  labelName
} from "./documents.selector";

export const DocumentCard = props => {
  let {
    documentDetails: {
      projectId,
      issueId,
      label,
      createdDate,
      createdByName,
      title,
      fileName,
      s3Url
    },
    index
  } = props;

  let fileExtension = getFileExtension(fileName);

  // For Different Background Color according to their Labels.
  let bgColor = getLabelColor(label);

  return (
    <div
      className="document-card"
      onClick={() => downloadFile(s3Url, title || fileName)}
      key={index}
    >
      <div className="d-flex flex-row justify-content-between align-items-center">
        <div className="doc-id-wrapper">
          {projectId && (
            <span className="doc-project-id">Project ID: {projectId}</span>
          )}
          {issueId && <span className="doc-issue-id">Issue ID: {issueId}</span>}
        </div>
        <div className="doc-label" style={{ backgroundColor: `${bgColor}` }}>
          {labelName[label]}
        </div>
      </div>
      <div className="doc-name">
        <ReadMore
          content={title || fileName}
          clamp={2}
          displayExpandButtons={false}
        />
      </div>
      {fileExtension && (
        <div className="doc-file-extension">
          <img src={attachmentIcon} alt="attachment icon" className="mr-1" />
          {fileExtension}
        </div>
      )}
      <div className="d-flex flex-row justify-content-between align-items-center doc-created-by-container">
        {createdByName && (
          <div className="doc-created-by">
            By <span>{createdByName}</span>
          </div>
        )}
        <div className="doc-created-date">
          Added on <span>{dateFormat(createdDate)}</span>
        </div>
      </div>
    </div>
  );
};
